import { APP_LINK } from '@components/MainWidget/FastagWidget/constants'
import { APPFLYER_DEEP_LINK } from '@constants/fastagConstants'

export const fetchDeepLink = async (regNo) => {
  try {
    const response = await fetch(APPFLYER_DEEP_LINK(regNo))

    if (!response.ok) {
      console.error('Failed to fetch the deep link')
    }

    const data = await response.json()
    const url = data?.url || APP_LINK
    window.location.href = url
  } catch (error) {
    console.info('REDIRECT TO DEFAULT URL')
    window.location.href = APP_LINK
    console.error('Error fetching deep link:', error)
  }
}
